<template>
	<div>
		<!-- Header Component -->
		<Header></Header>

		<div class="pa-container">
			<!-- Router View -->
			<!-- <router-view></router-view> -->
			<ErrorGeneral></ErrorGeneral>
		</div>
	</div>
</template>

<script>
import ErrorGeneral from "@/../../GeneralComponents/Errors/General";
import Header from "@/components/Header";

export default {
	name: "component_name",

	components: { ErrorGeneral, Header },

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped></style>
